import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { orderSearchInitialState } from './interfaces';
import { ISearchOrderResultData } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersResult';
import { ISearchOrdersSpecificationData } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrdersSpecification';

export const clientOrdersSearchReducer = createSlice({
  name: 'clientOrdersSearchReducer',
  initialState: orderSearchInitialState,
  reducers: {
    setClientOrdersSearchAction: (state, action: PayloadAction<ISearchOrderResultData>) => {
      state.searchResult = action.payload;
    },
    setClientOrdersSettingsAction: (state, action: PayloadAction<ISearchOrdersSpecificationData>) => {
      state.searchSettings = action.payload;
    },
    setClientOrdersSearchFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.searchResultFetchStatus = action.payload;
    },
    setClientOrdersSearchErrorAction: (state, action: PayloadAction<string | null>) => {
      state.searchResultError = action.payload;
    },
  },
});
export const {
  setClientOrdersSearchAction,
  setClientOrdersSearchFetchStatusAction,
  setClientOrdersSearchErrorAction,
  setClientOrdersSettingsAction,
} = clientOrdersSearchReducer.actions;
